var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitle flex between"},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.showmore)?_c('div',{staticClass:"FontSize14 FontGray"},[_vm._v(" 更多> ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }